export const API_MODE = "api";
export const IS_API_MODE = true;
